import React, { useEffect, useState } from "react";

import {
  ClientgetTeam,
  PatientDeleteTeam,
  PatientgetTeam,
} from "../../../../api/helper";
import { ShowToast } from "../../../../helpers/ToastService";
import Clientinternal from "./Clientinternal";
import ClientExternal from "./ClientExternal";
import ClientFacility from "./ClientFacility";
import DeleteModal from "../../Components/DeleteModal";

const CareTeam = ({ info }) => {
  // console.log(info,'===>>info')

  const [activeTab, setActiveTab] = useState("internal");
  const [ismodal, setismodal] = useState(false);
  const [members, setMembers] = useState(null);
  const [activedatatab, setactivedatatab] = useState("internal");
  const [selectedMember, setSelectedMember] = useState(null);
  const [confirmdeletemodal, setconfirmdeletemodal] = useState(false);
  const [deleteId, setdeleteId] = useState(null);

  const handledataTabClick = (tabId) => {
    setactivedatatab(tabId);
  };

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
  };

  const openModal = () => {
    setismodal(true);
  };

  const closeModal = () => {
    setSelectedMember(null);
    setismodal(false);
  };

  const Fetchteammember = async () => {
    try {
      const response = await ClientgetTeam(info?._id, activedatatab);
      setMembers(response?.data?.data?.TeamMember);
      // console.log(response?.data?.data?.TeamMember, "get======PatientgetTeam===");
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    Fetchteammember();
  }, [activedatatab]);

   const handleRemove = (id) => {
    setdeleteId(id);
    setconfirmdeletemodal(true);
  };

  const confirmDelete = async () => {
    setconfirmdeletemodal(false);
 
    try {
      const response = await PatientDeleteTeam(deleteId);
      ShowToast(response?.data?.message);
      Fetchteammember();
    } catch (error) {
      console.log(error);
    }
  };
  const handleEdit = (member) => {
    setSelectedMember(member);
    setActiveTab(activedatatab || "internal");
    setismodal(true);
  };
  return (
    <div className="container_NotesTabScreen">
      <h1>Care Team</h1>
      <button
        className="add-button_NotesTabScreen"
        style={{ float: "right" }}
        onClick={openModal}
      >
        Add Member
      </button>

      <div
        className="tabs-container__three"
        style={{ display: "flex", width: "100%", justifyContent: "left" }}
      />
      <div
        className="tabs-container__two"
        style={{ justifyContent: "flex-start" }}
      >
        <button
          className={`tab-button__two ${
            activedatatab === "internal" ? "active-tab__two" : ""
          }`}
          onClick={() => handledataTabClick("internal")}
        >
          Internal
        </button>
        <button
          className={`tab-button__two ${
            activedatatab === "external" ? "active-tab__two" : ""
          }`}
          onClick={() => handledataTabClick("external")}
        >
          External
        </button>
        <button
          className={`tab-button__two ${
            activedatatab === "facility" ? "active-tab__two" : ""
          }`}
          onClick={() => handledataTabClick("facility")}
        >
          Facility
        </button>
      </div>
  
  <table className="team-member-table">
    <thead>
      <tr>
        <th>Facility</th>
        <th>Provider Type</th>
        <th>Team Member</th>
        <th>From Date</th>
        <th>To Date</th>
        <th>Action</th>
      </tr>
    </thead>
    <tbody>
      {members && members.length > 0 ? (
        members.map((member) => (
          <tr key={member._id}>
            <td data-label="Facility">
              {member?.facilityId?.facilityName ||
                member.facility ||
                member?.practice ||
                "-"}
            </td>
            <td data-label="Provider Type">
              {member?.providerTypeId?.name || member.providerType || "-"}
            </td>
            <td data-label="Team Member">
              {member?.facilityExternalTeamId?.fullName ||
                member.teamMember ||
                "-"}
            </td>
            <td data-label="From Date">
              {new Date(member?.fromDate).toLocaleDateString()}
            </td>
            <td data-label="To Date">
              {new Date(member?.toDate).toLocaleDateString()}
            </td>
            <td className="custom-action-td" data-label="Action">
              <div className="custom-dropdown">
                <button className="custom-action-button">⋮ Actions</button>
                <div className="custom-dropdown-menu">
                  <ul>
                    <li>
                      <button
                        className="custom-dropdown-item"
                        onClick={() => handleEdit(member)}
                      >
                        Edit
                      </button>
                    </li>
                    <li>
                      <button
                        className="custom-dropdown-item"
                        onClick={() => handleRemove(member._id)}
                      >
                        Delete
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            </td>
          </tr>
        ))
      ) : (
        <tr>
          <td colSpan="6" style={{ textAlign: "center" }}>
            No Team Member found
          </td>
        </tr>
      )}
    </tbody>
  </table>


      {ismodal && (
        <>
          <div className="modal_twooo" id="add-member-modal">
            <h2>{selectedMember ? "Edit Team Member" : "Add Team Member"}</h2>
            {!selectedMember && (
              <div className="tab-buttons_twoooo">
                <button
                  className={activeTab === "internal" ? "active" : ""}
                  onClick={() => handleTabClick("internal")}
                >
                  Internal
                </button>
                <button
                  className={activeTab === "external" ? "active" : ""}
                  onClick={() => handleTabClick("external")}
                >
                  External
                </button>
                <button
                  className={activeTab === "facility" ? "active" : ""}
                  onClick={() => handleTabClick("facility")}
                >
                  Facility
                </button>
              </div>
            )}

            {activeTab === "internal" && (
              <Clientinternal
                info={info}
                Fetchteammember={Fetchteammember}
                closeModal={closeModal}
                selectedMember={selectedMember}
              />
            )}

            {activeTab === "external" && (
              <ClientExternal
                info={info}
                Fetchteammember={Fetchteammember}
                closeModal={closeModal}
                selectedMember={selectedMember}
              />
            )}

            {activeTab === "facility" && (
              <ClientFacility
                info={info}
                Fetchteammember={Fetchteammember}
                closeModal={closeModal}
                selectedMember={selectedMember}
              />
            )}
          </div>
        </>
      )}

      <div className="overlay" id="overlay" onClick={closeModal}></div>
      {confirmdeletemodal && (
        <DeleteModal
          name="Team Member"
          onClose={() => setconfirmdeletemodal(false)}
          onConfirm={confirmDelete}
        />
      )}
    </div>
  );
};

export default CareTeam;
